export default "__VITE_ASSET__DNqg3RpU__"